<template>
  <div class="container">
    <div class="landing"></div>
    <div class="overlay"></div>
    <div class="content">
      <Header color="white" type="page" />
      <div class="text text-center">
        <Tcon
          icon="f-exclamation-triangle-filled"
          class="exclamation-triangle"
        />
        <h1>This browser is not currently supported.</h1>
        <p>
          This browser is not currently supported by this application. Try one
          of the browsers below for the best experience.
        </p>
        <div>
          <img src="../assets/browsers/opera.svg" alt="Opera Browser logo" />
          <img
            src="../assets/browsers/firefox.svg"
            alt="Firefox Browser logo"
          />
          <img src="../assets/browsers/chrome.svg" alt="Chrome Browser logo" />
          <img src="../assets/browsers/safari.svg" alt="Safari Browser logo" />
          <img
            src="../assets/browsers/edge-chromium.svg"
            alt="Edge Chromium Browser logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Tcon from "../iconography/Tcon";
export default {
  name: "UnsupportedBrowser",
  components: {
    Header,
    Tcon,
  },
};
</script>

<style scoped>
.exclamation-triangle {
  padding-bottom: 2.5vh;
  width: 130px;
  fill: #ff585d;
  display: inline-block;
}

.landing {
  background: url("../assets/landing.jpg") no-repeat center center fixed;
  width: 100%;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -10;
  filter: blur(2px);
}

.overlay {
  width: 100%;
  height: 100%;
  background-color: #000;
  position: fixed;
  opacity: 0.7;
}

.container {
  width: 100%;
}

.content .text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  min-height: stretch;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  padding: 2.5vh 5vw;
}

h1 {
  font-size: 3rem;
  font-weight: 300;
  margin: 0;
  padding: 0 2rem;
  text-align: center;
}

p {
  font-size: 1.25rem;
  padding: 2rem 0;
  text-align: center;
}

img {
  height: 4rem;
  width: 4rem;
  margin: 0 0.5rem;
}
@media (max-width: 420px) {
  img {
    height: 2.4rem;
    width: 2.4rem;
    margin: 0 0.3rem;
  }
  h1 {
    font-size: 2rem;
  }
  .exclamation-triangle {
    width:90px;
  }
}
</style>
